import React from "react"
import "./ScoreRing.style.scss"
import { scoreToneClass } from "../utils/format"

interface ScoreRingProps {
  pct: number
  size?: number
}

const ScoreRing = ({ pct, size = 52 }: ScoreRingProps) => {
  const r = 46
  const circ = 2 * Math.PI * r
  const dash = (Math.min(100, Math.max(0, pct)) / 100) * circ

  return (
    <span className={`score-ring ${scoreToneClass(pct)}`} style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" aria-hidden>
        <circle className="score-ring__track" cx="50" cy="50" r={r} />
        <circle
          className="score-ring__value"
          cx="50"
          cy="50"
          r={r}
          strokeDasharray={`${dash} ${circ}`}
        />
      </svg>
      <span className="score-ring__label">{pct}%</span>
    </span>
  )
}

export default ScoreRing
